/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetEmailTemplateResponse
 */
export interface GetEmailTemplateResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetEmailTemplateResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetEmailTemplateResponse
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailTemplateResponse
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailTemplateResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailTemplateResponse
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof GetEmailTemplateResponse
     */
    body: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEmailTemplateResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetEmailTemplateResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetEmailTemplateResponse
     */
    updatedAt: Date | null;
}

/**
 * Check if a given object implements the GetEmailTemplateResponse interface.
 */
export function instanceOfGetEmailTemplateResponse(value: object): value is GetEmailTemplateResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GetEmailTemplateResponseFromJSON(json: any): GetEmailTemplateResponse {
    return GetEmailTemplateResponseFromJSONTyped(json, false);
}

export function GetEmailTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmailTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'type': json['type'],
        'key': json['key'],
        'displayName': json['displayName'],
        'subject': json['subject'],
        'body': json['body'],
        'isActive': json['isActive'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

export function GetEmailTemplateResponseToJSON(json: any): GetEmailTemplateResponse {
    return GetEmailTemplateResponseToJSONTyped(json, false);
}

export function GetEmailTemplateResponseToJSONTyped(value?: GetEmailTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'type': value['type'],
        'key': value['key'],
        'displayName': value['displayName'],
        'subject': value['subject'],
        'body': value['body'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

